<template>
  <div>
    <table class="table table-sm table-hover table-striped">
      <tbody>
      <tr v-for="(div) in $AllDivisions" v-if="div.is_active && div.id !== 7">
        <td>
          {{
            div?.user?.name || 'Не определен'
          }}
          ({{
            div?.cities[0]?.city?.name || 'не указан'
          }})
        </td>
        <td class="balance_td">
          <template v-if="loadingBalance[div.id]">
            <pulse-loader size="10px"/>
          </template>
          <template v-else>
            <p v-for="(bData, currId) in (balanceReport[div.id]?.balance ?? [])" v-if="+bData.amount">
              {{ $AllCurrencies[currId].currency }}: <strong>{{
                Math.round(bData.amount).toLocaleString('ru-RU')
              }}</strong>
            </p>
          </template>
        </td>
      </tr>
      <tr class="total_tr">
        <td class="text-right">ИТОГО</td>
        <td class="text-left">EUR: {{ printDivBalanceSum() }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from "@/api";
import moment from 'moment';

export default {
  props: ['setDate'],
  data() {
    return {
      loadingBalance: {},
      balanceReport: {},
      keepUpdating: true,
    }
  },
  beforeDestroy() {
    this.keepUpdating = false;
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  created() {
    this.showDivBalance();
  },
  methods: {
    async showDivBalance() {
      this.loadingBalance = Object.keys(this.$AllDivisions).reduce((acc, d) => {
        acc[d] = true;
        return acc;
      }, {})
      const divIds = Object.keys(this.$AllDivisions).filter((d) => +d !== 7);
      const date = this.setDate ?? moment().format('DD.MM.YYYY');
      for (let index = 0; index < divIds.length; index++) {
        if (!this.keepUpdating) return;
        const {data} = await api.index(`/reports/division/balance?date=${date}&divId=${divIds[index]}`);
        if (data.success) {
          this.$set(this.balanceReport, divIds[index], data.divisionBalance);
          this.loadingBalance[divIds[index]] = false;
        }
      }
    },
    printDivBalanceSum() {
      let sum = 0;
      Object.keys(this.balanceReport ?? {}).forEach((d) => {
        Object.keys(this.balanceReport[d].balance).forEach((currId) => {
          sum += this.balanceReport[d].balance[currId].amount * this.$AllCurrencies[currId].rate;
        })
      })
      return Math.round(sum).toLocaleString('ru-RU');
    }
  }
}

</script>

<style scoped>
.table .total_tr {
  font-weight: 600;
  background-color: #d8ffd8;
}

.balance_td {
  min-width: 55px;
}

.table td {
  padding: 2px 5px;
}

table p {
  margin-bottom: 2px;
}
</style>
